// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogContent-titleText-SL7rw {
	font-size: 36px;
	color: var(--common-text-color);
	text-align: center;
	font-weight: 700;
}

.BlogContent-subText-pF9Th {
	margin-top: 45px;
	font-size: 16px;
	color: var(--common-text-color);
	text-align: justify;
	font-weight: 300;
	font-style: normal;
}

.BlogContent-spaceTop3-YLAC4 {
	margin-bottom: 18px;
}

.BlogContent-space6-DFtuv {
	margin-bottom: 30px;
}

.BlogContent-root-Ts2dl {
	width: 100%;
	max-width: 1080px;
	margin: 0 auto;
}

h1 {
	font-size: 28px;
	color: var(--common-text-color);
	font-weight: 700;
}

h2 {
	font-size: 20px;
	color: var(--common-text-color);
	font-weight: 700;
}

.BlogContent-bannerContainer-TBqi3 {
	padding-top: 48px;
	max-width: 1080px;
	margin: 0 auto;
}

.BlogContent-bannerHeader-P1889 {
	position: relative;
	min-height: calc(100vh - 84px);
}

.BlogContent-realtivePosition-kkC3u {
	position: relative;
}

.BlogContent-previewPageWrapper-V1uXT {
	margin-top: 45px;
	min-height: 600px;
}

@media screen and (min-width: 768px) {
	.BlogContent-captionText-nLJDf {
		position: absolute !important;
		top: 15px;
		left: 0;
		right: 0;
		-webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);
		        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);
		margin: 0 auto;
	}
}

@media (max-width: 1199px) and (min-width: 768px) {
	.BlogContent-previewPageWrapper-V1uXT {
		min-height: 350px;
	}
}

@media (max-width: 767px) {
	.BlogContent-previewPageWrapper-V1uXT {
		min-height: 250px;
	}
}

@media screen and (max-width: 640px) {
	.BlogContent-bannerContainer-TBqi3 {
		padding-top: 28px;
	}

	.BlogContent-bannerHeader-P1889 {
		position: relative;
		min-height: 680px;
	}

	h1 {
		text-align: left;
	}

	h2 {
		text-align: left;
	}
}

/** Banner caption - End **/`, "",{"version":3,"sources":["webpack://./src/components/BlogContent/BlogContent.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,+BAA+B;CAC/B,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,+BAA+B;CAC/B,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,8BAA8B;AAC/B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC;EACC,6BAA6B;EAC7B,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kDAA0C;UAA1C,0CAA0C;EAC1C,cAAc;CACf;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD;;AAEA,2BAA2B","sourcesContent":[".titleText {\n\tfont-size: 36px;\n\tcolor: var(--common-text-color);\n\ttext-align: center;\n\tfont-weight: 700;\n}\n\n.subText {\n\tmargin-top: 45px;\n\tfont-size: 16px;\n\tcolor: var(--common-text-color);\n\ttext-align: justify;\n\tfont-weight: 300;\n\tfont-style: normal;\n}\n\n.spaceTop3 {\n\tmargin-bottom: 18px;\n}\n\n.space6 {\n\tmargin-bottom: 30px;\n}\n\n.root {\n\twidth: 100%;\n\tmax-width: 1080px;\n\tmargin: 0 auto;\n}\n\nh1 {\n\tfont-size: 28px;\n\tcolor: var(--common-text-color);\n\tfont-weight: 700;\n}\n\nh2 {\n\tfont-size: 20px;\n\tcolor: var(--common-text-color);\n\tfont-weight: 700;\n}\n\n.bannerContainer {\n\tpadding-top: 48px;\n\tmax-width: 1080px;\n\tmargin: 0 auto;\n}\n\n.bannerHeader {\n\tposition: relative;\n\tmin-height: calc(100vh - 84px);\n}\n\n.realtivePosition {\n\tposition: relative;\n}\n\n.previewPageWrapper {\n\tmargin-top: 45px;\n\tmin-height: 600px;\n}\n\n@media screen and (min-width: 768px) {\n\t.captionText {\n\t\tposition: absolute !important;\n\t\ttop: 15px;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbox-shadow: 0 1px 3px 0 rgba(0, 0, 0, .08);\n\t\tmargin: 0 auto;\n\t}\n}\n\n@media (max-width: 1199px) and (min-width: 768px) {\n\t.previewPageWrapper {\n\t\tmin-height: 350px;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.previewPageWrapper {\n\t\tmin-height: 250px;\n\t}\n}\n\n@media screen and (max-width: 640px) {\n\t.bannerContainer {\n\t\tpadding-top: 28px;\n\t}\n\n\t.bannerHeader {\n\t\tposition: relative;\n\t\tmin-height: 680px;\n\t}\n\n\th1 {\n\t\ttext-align: left;\n\t}\n\n\th2 {\n\t\ttext-align: left;\n\t}\n}\n\n/** Banner caption - End **/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleText": `BlogContent-titleText-SL7rw`,
	"subText": `BlogContent-subText-pF9Th`,
	"spaceTop3": `BlogContent-spaceTop3-YLAC4`,
	"space6": `BlogContent-space6-DFtuv`,
	"root": `BlogContent-root-Ts2dl`,
	"bannerContainer": `BlogContent-bannerContainer-TBqi3`,
	"bannerHeader": `BlogContent-bannerHeader-P1889`,
	"realtivePosition": `BlogContent-realtivePosition-kkC3u`,
	"previewPageWrapper": `BlogContent-previewPageWrapper-V1uXT`,
	"captionText": `BlogContent-captionText-nLJDf`
};
module.exports = ___CSS_LOADER_EXPORT___;
